/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LocatorLocalAtendimentoAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  BUTTON_SELECIONAR = 'button-selecionar',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_0 = 'fetch-0',
  FETCH_1 = 'fetch-1',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FILTER_0 = 'filter-0',
  FILTERED_LIST_0 = 'filtered-list-0',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  MAPPER_0 = 'mapper-0',
  PANEL_LOCAL_ATENDIMENTO = 'panel-local-atendimento',
  TABLE = 'table',
  TABLE_COLUMN_0 = 'table-column-0',
  TABLE_COLUMN_1 = 'table-column-1',
  TABLE_COLUMN_2 = 'table-column-2',
  TEXT_0 = 'text-0',
}
export { LocatorLocalAtendimentoAliases };
